import {z} from 'zod';

import i18n from '@dms/i18n';

const requiredMessage = (): string => i18n.t('general.notifications.errorFieldRequired');

const emptyToUndefined = <T>(v: T): T | undefined => (v === null || v === '' ? undefined : v);

const requiredString = () =>
  z
    .string()
    .transform(emptyToUndefined)
    .refine((v) => v !== undefined, {message: requiredMessage()});

export const VehicleSeriesDefinitionFormValidations = z.object({
  branchId: z.string().nullable().default(null),
  seriesId: requiredString(),
  makes: z
    .array(z.string())
    .transform((i) => (Array.isArray(i) && i.length === 0 ? null : Array.isArray(i) ? i : null))
    .nullable()
    .default(null),
  name: requiredString(),
  vehicleType: requiredString(),
});

export const VehicleSeriesSystemDefinitionFormValidations = z.object({
  name: requiredString(),
});
